import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import {
  MultiSelectorContextProvider,
  makeUseOptionsAsyncDataSource,
  makeUseSelectedOptionsAsyncDataSource,
  useMultiSelectContext,
} from '@bingads-webui-campaign-react/multi-selector';
import { loadBrandsFactoryFromProp, loadBrandsUnderBrandListFactoryFromProp } from '@bingads-webui-campaign-react/brand-lists-data';
import { BRAND_SELECTED_OPTIONS_LIMIT } from '../constants';

export const BrandsContextProvider = ({
  children,
  cid,
  aid,
  brandListId,
  selectedOptionsLimit,
  optionsDisplayLimit,
  loadBrandsFactory,
  loadAssociatedBrandsFactory,
  onChange,
  savedAddedSelectedOptionsKeys,
  savedDeletedSelectedOptionsKeys,
}) => {
  const loadBrands = useMemo(() => loadBrandsFactory({ cid, aid }), [aid, cid, loadBrandsFactory]);
  const useOptions = useMemo(() => makeUseOptionsAsyncDataSource(loadBrands), [loadBrands]);

  const loadBrandsUnderBrandList = useMemo(() => loadAssociatedBrandsFactory({
    cid, aid, brandListId, isEdit: brandListId, top: BRAND_SELECTED_OPTIONS_LIMIT,
  }), [aid, brandListId, cid, loadAssociatedBrandsFactory]);
  const useOptionsUnderBrandList = useMemo(() => makeUseSelectedOptionsAsyncDataSource(loadBrandsUnderBrandList), [loadBrandsUnderBrandList]);

  return (
    <MultiSelectorContextProvider
      useOptions={useOptions}
      useSelectedOptions={useOptionsUnderBrandList}
      selectedOptionsLimit={selectedOptionsLimit}
      optionsDisplayLimit={optionsDisplayLimit}
      onChange={onChange}
      savedAddedSelectedOptionsKeys={savedAddedSelectedOptionsKeys}
      savedDeletedSelectedOptionsKeys={savedDeletedSelectedOptionsKeys}
    >
      {children}
    </MultiSelectorContextProvider>
  );
};

BrandsContextProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  cid: PropTypes.number.isRequired,
  aid: PropTypes.number.isRequired,
  brandListId: PropTypes.number,
  selectedOptionsLimit: PropTypes.number.isRequired,
  optionsDisplayLimit: PropTypes.number.isRequired,
  loadBrandsFactory: PropTypes.func,
  loadAssociatedBrandsFactory: PropTypes.func,
  onChange: PropTypes.func.isRequired,
  savedAddedSelectedOptionsKeys: PropTypes.arrayOf(PropTypes.number),
  savedDeletedSelectedOptionsKeys: PropTypes.arrayOf(PropTypes.number),
};

BrandsContextProvider.defaultProps = {
  brandListId: undefined,
  loadBrandsFactory: loadBrandsFactoryFromProp,
  loadAssociatedBrandsFactory: loadBrandsUnderBrandListFactoryFromProp,
  savedAddedSelectedOptionsKeys: [],
  savedDeletedSelectedOptionsKeys: [],
};

export const useBrandsData = useMultiSelectContext;

